import React from "react";
import ApproachCard from "./Components/ApproachCard";
import SectionHeader from "../../../../Components/SectionHeader";

const AboutUsApproachSection = () => {
  return (
    <section className="relative p-4 md:p-20 mt-[4%] mb-[28%] md:my-[4%]">
      <SectionHeader
        childClassName="md:px-[4%] text-base md:text-lg"
        tagline="our approach"
        title={
          <div>
            Curious about how we
            <br /> make AI work for you?
          </div>
        }
        description="We scale AI with a Dual focus on Strategy and Execution"
      />
      <ApproachCard
        title="Our vision"
        imageUrl="/images/about-us-page/about-us-image-2.jpeg"
        description="We help organizations unlock AI’s true potential with solutions that are both strategic and practical. By blending vision with technical expertise, we guide clients through complexity, reveal hidden opportunities, and drive meaningful progress turning possibilities into tangible impact."
      />
    </section>
  );
};

export default AboutUsApproachSection;
